import { useAtomValue } from 'jotai';
import { comparisonGameFiltersToPersistAtom, filtersToPersistAtom } from '@/atoms/filters/persistedFilters';
import {
  comparisonTeamCompetitionIdsToFilterByAtom,
  comparisonTeamSeasonIdsToFilterByAtom,
} from '@/atoms/filters/team/teamComparisonFilters';
import { teamComparisonEventsForMetricCountAtom } from '@/atoms/queries/team/teamEventDataComparison';
import { EntityMetricPreviewPanel } from '@/components/preview/EntityMetricPreviewPanel';
import { TeamComparisonPreviewEvents } from '@/components/team/radar/preview/TeamPreviewEventsComparison';
import { TeamComparisonEventMap } from '@/components/team/vis/TeamEventMapComparison';
import { COMPARISON_ID } from '@/consts/searchKeys';
import { useQueryParam } from '@/hooks/useQueryParam';

export const TeamComparisonPreviewPanel = () => {
  const comparisonId = useQueryParam(COMPARISON_ID);
  const filters = useAtomValue(filtersToPersistAtom);
  const comparisonGameFilters = useAtomValue(comparisonGameFiltersToPersistAtom);
  const comparisonCompetitionIds = useAtomValue(comparisonTeamCompetitionIdsToFilterByAtom);
  const comparisonSeasonIds = useAtomValue(comparisonTeamSeasonIdsToFilterByAtom);
  const comparisonFilters = {
    ...filters,
    ...comparisonGameFilters,
    competitionIds: comparisonCompetitionIds,
    seasonIds: comparisonSeasonIds,
  };

  return (
    <EntityMetricPreviewPanel
      pathTo={comparisonId ? `../../../team/${comparisonId}/vis` : undefined}
      eventsForMetricCountAtom={teamComparisonEventsForMetricCountAtom}
      filtersToHydrate={comparisonFilters}
      eventMap={<TeamComparisonEventMap isPreview />}
    >
      <TeamComparisonPreviewEvents />
    </EntityMetricPreviewPanel>
  );
};
